((Drupal, drupalSettings, debounce, once, $, window) => {
  /**
   * Core/Misc behaviours.
   */
  Drupal.behaviors.wncCarnationMisc = {
    attach: function attach(context, settings) {
      once("example", ".example", context).forEach(() => {
        settings.example = true;
      });
    },
  };

  /**
   * "Return to top" button functionality.
   *
   * @type {{attach: Drupal.behaviors.wncCarnationBackToTop.attach}}
   */
  Drupal.behaviors.wncCarnationBackToTop = {
    attach: function attach(context) {
      const backToTop = $(".return-to-top", context);

      if (!once("return-top-top-scroll", "html").length) {
        return;
      }

      $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
          backToTop.addClass("show");
        } else {
          backToTop.removeClass("show");
        }
      });

      $(once("return-top-top-click", ".return-to-top")).on(
        "click",
        function (e) {
          e.preventDefault();
          $("html, body").animate({ scrollTop: 0 }, "300");
        }
      );
    },
  };

  /**
   * Override Openy Mobile menu behaviour.
   */
  Drupal.behaviors.openyMobileMenu = {
    attach: function attach(context) {
      const $sidebar = $("#sidebar", context);
      const $overlay = $(".mobile-overlay", context);

      $sidebar.on("show.bs.collapse hide.bs.collapse", function () {
        // Control overlay display.
        $overlay.toggleClass("show");

        // Additional flag to set css transition.
        $sidebar.toggleClass("sidebar-collapsed");

        // Prevent scrolling in the background.
        $("body").toggleClass("no-scroll");
      });

      let googleTranslateInitialized = false;

      // Make sure the google translate widget is visible in the sidebar.
      $sidebar.on("shown.bs.collapse", function () {
        const $elem = $(".openy-google-translate:visible", $sidebar).get(0);

        if ($elem !== undefined && !googleTranslateInitialized) {
          const googleTranslateElement = new google.translate.TranslateElement(
            {
              pageLanguage: drupalSettings.path.currentLanguage,
              layout: google.translate.TranslateElement.InlineLayout.VERTICAL,
            },
            $elem
          );

          if (googleTranslateElement !== undefined) {
            googleTranslateInitialized = true;
          }
        }
      });

      // Add "collapsing" class when dropdown is being hidden.
      // Remove "collapse" class when hide animation is triggered because
      // "collapse" applies "display:none", removing the animation altogether.
      $sidebar.on("hide.bs.collapse", function () {
        $sidebar.toggleClass("collapse").toggleClass("collapsing");
      });
    },
  };

  /**
   * Alert Modals
   */
  Drupal.behaviors.openyAlertModals = {
    attach: function attach(context) {
      function triggerModals(contextVal) {
        const alertModals = $(".alert-modal", contextVal);

        if (alertModals.length) {
          alertModals.on("hidden.bs.modal", function () {
            $(this).remove();
          });
          alertModals.modal("show");
        }
      }

      // Trigger modals on page load.
      triggerModals();

      // Check again on ajaxStop to handle form alerts.
      $(context).ajaxStop(function () {
        triggerModals(context);
      });
    },
  };

  /**
   * Handle 2nd level dropdown links in mobile menu.
   */
  Drupal.behaviors.wncMobileMenu = {
    attach: function attach(context) {
      // Expand 3rd level dropdowns.
      $("#sidebar .mobile-navigation-menu .nav-level-3 .d-toggle", context).on(
        "click",
        function (e) {
          const $this = $(this);

          e.stopPropagation();
          e.preventDefault();

          // Mark current menu and sub-menus as expanded.
          $this.toggleClass("expanded");
          $this
            .siblings(".row-level-3")
            .toggleClass("d-none")
            .toggleClass("d-block");

          // Close any other open menus.
          $this
            .parent()
            .siblings()
            .find(".d-block")
            .toggleClass("d-block")
            .toggleClass("d-none");
        }
      );
    },
  };

  /**
   * Add clip-patch to the elements.
   */
  Drupal.behaviors.clipPath = {
    attach: function attach(context) {
      $(once("onInit", ".block-ping-pong", context)).each(function () {
        if (
          $(this).hasClass("ping-pong-item--image-left") &&
          $(this).find(".item-image .image")
        ) {
          $(this)
            .find(".item-image .image")
            .css("clip-path", "url('#ping-pong-svg-clip-left')");
        } else {
          $(this)
            .find(".item-image .image")
            .css("clip-path", "url('#ping-pong-svg-clip-right')");
        }
      });

      const clipBannerClasses = [
        ".hero_banner-image",
        ".hero_banner-video--youtube-player-wrapper",
        ".hero_banner-video--video-player-wrapper",
        ".hero_banner-video--vimeo-player-wrapper",
      ];

      $.each(clipBannerClasses, function (key, value) {
        $(once("onInit", value, context)).each(function () {
          if ($(window).width() >= 767) {
            $(this).css("clip-path", "url('#banner-svg-clip')");
          } else {
            $(this).css("clip-path", "url('#banner-svg-clip-mobile')");
          }
        });
      });
    },
  };

  /**
   * Updated margin-top if Alert added.
   */
  function updateMarginTopForAlert() {
    var $viewport = $('body .viewport');
    var $alert = $('#openy_alerts_header_placeholder');
    let margin_top = parseInt($viewport.css('margin-top')) + $alert.outerHeight();
    $viewport.css("margin-top", margin_top);
  };

  const debounceHeader = Drupal.debounce(function () {
    const vh = window.innerHeight * 0.01;
    // Add global variables.
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  }, 250);

  window.addEventListener("load", debounceHeader);
  window.addEventListener("resize", debounceHeader);
  window.addEventListener("visibilitychange", debounceHeader);

  // Add event listener for the alert container wrapper.
  const debounceAlert = Drupal.debounce(function (entries) {
    document.documentElement.style.setProperty(
      "--alert-height",
      `${entries[0].target.offsetHeight}px`
    );
    debounceHeader();
    updateMarginTopForAlert();
  }, 10);

  const alertBlock = document.getElementById("openy_alerts_header_placeholder");

  if (alertBlock !== null) {
    new ResizeObserver(debounceAlert).observe(alertBlock);
  }
})(Drupal, drupalSettings, Drupal.debounce, once, jQuery, window);
